import React, { useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { CFCProps, AUTH_TYPE } from 'types';
import { RootState } from 'redux/root.reducer';
import { Loading } from 'carbon-components-react';
import { signInForExternalApp } from 'redux/auth/action';
import { setAppLoginType } from 'redux/app/actions';
import Service from 'services';

export const Locate: React.FC<Props> = (props: Props) => {
  const { login } = props;
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<{ from?: Location }>();
  const { isSingedInForExternalApp, error }: any = login;

  useEffect(() => {
    const queryString = new URLSearchParams(location.search);
    const token = queryString.get('token') || '';
    const username = queryString.get('username') || '';
    if (token && username && window.self !== window.top) {
      dispatch(setAppLoginType(AUTH_TYPE.EXTERNAL_APP_LOGIN));
      const params = {
        token,
        username
      };
      dispatch(signInForExternalApp(params));
    } else {
      dispatch(setAppLoginType(null));
      Service.auth.ssoLogout();
    }
  }, [location, dispatch, history]);

  useEffect(() => {
    if (isSingedInForExternalApp) {
      const message = 'External app logged in successfully';
      const targetOrigin =
        process.env.REACT_APP_LOCATE_WEB_URL ||
        'https://locate.smarterwx.com.au';
      window.parent.postMessage(message, targetOrigin);
    }
  }, [isSingedInForExternalApp]);

  return (
    <>
      {error ? <h1>Retry</h1> : isSingedInForExternalApp ? <></> : <Loading />}
    </>
  );
};

const mapStateToProps = ({ app, login, session }: RootState) => ({
  app,
  login,
  session
});

const connector = connect(mapStateToProps);
type Props = CFCProps<typeof connector>;
Locate.displayName = 'ExternalApp';

export default connector(Locate);
